import CancelPolicy from './CancelPolicy';

export default CancelPolicy;
